// FIX-M2 : orgchartApi et OrgPosition extraits de tickets.api.ts
// vers leur propre fichier module, conformément à la séparation des modules.
//
// OrgchartMain.tsx doit importer depuis ce fichier :
//   import { orgchartApi, type OrgPosition } from '@/modules/orgchart/api/orgchart.api'

import api from '@/lib/axios'

// FIX: TransformInterceptor wrappe les réponses en { success, data, timestamp }
// r.data = réponse Axios = { success, data, timestamp } → r.data.data = contenu réel
const R = (r: any) => r.data.data

// ─── Types ────────────────────────────────────────────────────────────────────

export interface OrgPosition {
  id: string
  title: string
  level: number
  order: number
  isVacant: boolean
  parentId?: string
  departmentId?: string
  employeeId?: string
  employee?: {
    id: string
    jobTitle?: string
    user: { firstName: string; lastName: string; avatarUrl?: string; email: string }
  }
  department?: { id: string; name: string }
  children?: OrgPosition[]
}

// ─── API ──────────────────────────────────────────────────────────────────────

export const orgchartApi = {
  getTree: (params?: { departmentId?: string; showVacant?: boolean }) =>
    api.get('/orgchart', { params }).then(R),

  getFlat: (departmentId?: string) =>
    api.get('/orgchart/flat', { params: { departmentId } }).then(R),

  getStats: () =>
    api.get('/orgchart/stats').then(R),

  getPosition: (id: string) =>
    api.get(`/orgchart/${id}`).then(R),

  createPosition: (data: any) =>
    api.post('/orgchart', data).then(R),

  updatePosition: (id: string, d: any) =>
    api.patch(`/orgchart/${id}`, d).then(R),

  movePosition: (id: string, newParentId: string) =>
    api.patch(`/orgchart/${id}/move`, { newParentId }).then(R),

  deletePosition: (id: string) =>
    api.delete(`/orgchart/${id}`).then(R),
}
